module.exports = __webpack_public_path__ + "static/media/community-builder-3.48c12de3.png";